import { MetaTags } from 'components/MetaTags';
import { Container } from '@morressier/ts';
import PosterGrid from '../PosterGrid/index';

const GridPreloader = () => (
  <>
    <MetaTags title="Loading..." />
    <Container className="mt5" style={{ width: '100%' }}>
      <>
        <div
          style={{
            marginBottom: '2rem',
          }}
        >
          <PosterGrid
            items={[
              {
                id: '1',
              },
              {
                id: '2',
              },
              {
                id: '3',
              },
            ]}
          />
        </div>
      </>
    </Container>
  </>
);

export default GridPreloader;
